import React from "react";
import PropTypes from "prop-types";

const TooltipTemplate = ({ item }) => {
  
  return (
    <span>{ item }</span>
  );
};

TooltipTemplate.propTypes = {
  item: PropTypes.string,
};

export default TooltipTemplate;
